import { GeneralLayout } from "@components";
import { lazy } from "react";

import OrganizationContextProvider from "../../../context/organization-context";
import { memberSettingsPathPrefix } from "../../../path";
import memberMainMenuList from "./menu";
import {
  CUSTOM_FIELDS_LIST_PATH,
  CUSTOM_FIELD_NEW_FORM,
  CUSTOM_FIELD_UPDATE_FORM,
  INTEGRATIONS,
  INVOICE_SETTINGS_PATH,
  NEW_ORGANIZATION_PATH,
  ORGANIZATION_PATH,
  PROFILE_PATH,
  SERVICES_LIST_PATH,
  SERVICE_DETAIL_PATH,
  SLACK_INTEGRATION_PATH,
  STRIPE_ACCOUNT_RETURN_PATH,
  TIME_ENTRIES_SETTINGS_PATH,
} from "./paths";

const EditOrganization = lazy(
  () => import("@src/modules/member/modules/settings/organization"),
);
const NewOrganization = lazy(
  () =>
    import(
      "@src/modules/member/modules/settings/organization/new-organization"
    ),
);
const Profile = lazy(
  () => import("@src/modules/member/modules/settings/profile"),
);
const StripeAccountReturn = lazy(
  () =>
    import(
      "@src/modules/member/modules/settings/organization/stripe-account-return"
    ),
);
const InvoicesSettings = lazy(
  () => import("@src/modules/member/modules/settings/invoices"),
);
const CustomFieldList = lazy(
  () => import("@src/modules/member/modules/settings/custom-fields"),
);
const UpdateCustomField = lazy(
  () => import("@src/modules/member/modules/settings/custom-fields/update"),
);
const NewCustomField = lazy(
  () => import("@src/modules/member/modules/settings/custom-fields/new"),
);

const Integrations = lazy(
  () => import("@src/modules/member/modules/settings/integrations"),
);
const SlackIntegrationDetail = lazy(
  () =>
    import("@src/modules/member/modules/settings/integrations/slack-detail"),
);
const ServiceList = lazy(
  () => import("@src/modules/member/modules/settings/services/list"),
);
const ServiceDetail = lazy(
  () => import("@src/modules/member/modules/settings/services/details"),
);
const TimeEntriesSettings = lazy(
  () => import("@src/modules/member/modules/settings/time-entries"),
);

const memberSettingsPath = `${memberSettingsPathPrefix}/`;
const protectedMemberRoutes = [
  {
    path: `settings/${NEW_ORGANIZATION_PATH(true, memberSettingsPath)}`,
    element: <NewOrganization />,
  },
  {
    path: "settings",
    element: (
      <OrganizationContextProvider>
        <GeneralLayout menuList={memberMainMenuList} extraMenu={[]} />
      </OrganizationContextProvider>
    ),
    children: [
      {
        path: INVOICE_SETTINGS_PATH(true, memberSettingsPath),
        element: <InvoicesSettings />,
      },
      {
        path: STRIPE_ACCOUNT_RETURN_PATH(true, memberSettingsPath),
        element: <StripeAccountReturn />,
      },
      {
        path: ORGANIZATION_PATH(true, memberSettingsPath),
        element: <EditOrganization />,
      },
      {
        path: PROFILE_PATH(true, memberSettingsPath),
        element: <Profile />,
      },
      {
        path: CUSTOM_FIELDS_LIST_PATH(true, memberSettingsPath),
        element: <CustomFieldList />,
      },
      {
        path: CUSTOM_FIELD_UPDATE_FORM(true, memberSettingsPath, ":code"),
        element: <UpdateCustomField />,
      },
      {
        path: CUSTOM_FIELD_NEW_FORM(true, memberSettingsPath),
        element: <NewCustomField />,
      },
      {
        path: SERVICES_LIST_PATH(true, memberSettingsPath),
        element: <ServiceList />,
      },
      {
        path: SERVICE_DETAIL_PATH(true, memberSettingsPath, ":code"),
        element: <ServiceDetail />,
      },
      {
        path: TIME_ENTRIES_SETTINGS_PATH(true, memberSettingsPath),
        element: <TimeEntriesSettings />,
      },
      {
        path: INTEGRATIONS(true),
        element: <Integrations />,
      },
      {
        path: SLACK_INTEGRATION_PATH(true, memberSettingsPath),
        element: <SlackIntegrationDetail />,
      },
    ],
  },
];

export default protectedMemberRoutes;
